import type {
    IMaterialResponse,
    IFile,
} from '@alfa-bank/site-invest-mediaportal-common/src/models';

export const getFileBanner = (article: IMaterialResponse): IFile | undefined =>
    article.files?.find(file => file.type === 'banner');
